/**
 * Admin dashboard layout.
 */

import { Outlet, NavLink, Link } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider.jsx';
import { Logo } from '../components/brand/Logo.jsx';
import { Badge } from '../components/ui/Badge.jsx';
import { ThemeToggle } from '../components/ui/ThemeToggle.jsx';
import styles from './AdminLayout.module.css';
import { config } from '../config/appConfig.js';

const NAV = [
  { to: '/admin', label: 'Overview', end: true, adminOnly: false },
  { to: '/admin/moderation', label: 'Moderation', adminOnly: false },
  { to: '/admin/reports', label: 'Reports', adminOnly: false },
  { to: '/admin/users', label: 'Users', adminOnly: true },
  { to: '/admin/subscriptions', label: 'Subscriptions', adminOnly: true },
  { to: '/admin/songs', label: 'Songs', adminOnly: true },
  { to: '/admin/chords', label: 'Chord library', adminOnly: true },
  { to: '/admin/learn', label: 'Learn curriculum', adminOnly: true },
  { to: '/admin/audit-logs', label: 'Audit log', adminOnly: true },
];

export function AdminLayout() {
  const { profile, isAdmin } = useAuth();

  const visible = NAV.filter((item) => !item.adminOnly || isAdmin);

  return (
    <div className={styles.shell}>
      <a href="#admin-main" className="skip-link">
        Skip to content
      </a>

      <aside className={styles.sidebar}>
        <div className={styles.sidebarHeader}>
          <Link to="/admin" className={styles.logoLink} aria-label="Admin home">
            <Logo size={24} />
          </Link>
          <Badge tone="accent" size="sm">
            {isAdmin ? 'Admin' : 'Moderator'}
          </Badge>
        </div>

        <nav className={styles.nav} aria-label="Admin sections">
          {visible.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `${styles.navItem} ${isActive ? styles.navActive : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className={styles.sidebarFooter}>
          <p className={styles.account}>{profile?.email}</p>
          <Link to="/app" className={styles.backLink}>
            ← Back to {config.appName}
          </Link>
        </div>
      </aside>

      <div className={styles.content}>
        <header className={styles.topBar}>
          <h1 className={styles.title}>Admin</h1>
          <ThemeToggle />
        </header>

        <main id="admin-main" className={styles.main}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
